<script setup lang="ts">
const appConfig = useAppConfig()
const { accessibleItems } = useSidebar()

let isOpen = useState('collapse-open')
isOpen.value = false

watchEffect(() => {
  if (appConfig.tairo.collapse?.navigation) {
    appConfig.tairo.collapse.navigation.items = accessibleItems.value
  }
})
</script>

<template>
  <TairoCollapseLayout :toolbar="false" :horizontal-scroll="true">
    <slot />
  </TairoCollapseLayout>
</template>
